"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _axios = _interopRequireDefault(require("axios"));

var _Authentication = _interopRequireDefault(require("./Authentication"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var APIRequest = /*#__PURE__*/function () {
  function APIRequest() {
    _classCallCheck(this, APIRequest);
  }

  _createClass(APIRequest, [{
    key: "_updateConfig",
    value: function _updateConfig(config) {
      if (config === undefined) {
        config = {};
      }

      if (config.headers === undefined) {
        config.headers = {};
      }

      return _objectSpread(_objectSpread({}, config), {}, {
        headers: _objectSpread(_objectSpread({}, config.headers), {}, {
          'Authorization': "Bearer " + _Authentication.default.getAccessToken()
        })
      });
    }
  }, {
    key: "get",
    value: function get(url, config) {
      var _this = this;

      return new Promise(function (resolve, reject) {
        _axios.default.get(url, _this._updateConfig(config)).then(function (res) {
          resolve(res);
        }).catch(function (err) {
          if (err.response !== undefined) {
            if (err.response.status === 401) {
              return _Authentication.default.logout();
            }
          }

          reject(err);
        });
      });
    }
  }, {
    key: "delete",
    value: function _delete(url, config) {
      var _this2 = this;

      return new Promise(function (resolve, reject) {
        _axios.default.delete(url, _this2._updateConfig(config)).then(function (res) {
          resolve(res);
        }).catch(function (err) {
          if (err.response !== undefined) {
            if (err.response.status === 401) {
              return _Authentication.default.logout();
            }
          }

          reject(err);
        });
      });
    }
  }, {
    key: "head",
    value: function head(url, config) {
      var _this3 = this;

      return new Promise(function (resolve, reject) {
        _axios.default.head(url, _this3._updateConfig(config)).then(function (res) {
          resolve(res);
        }).catch(function (err) {
          if (err.response !== undefined) {
            if (err.response.status === 401) {
              return _Authentication.default.logout();
            }
          }

          reject(err);
        });
      });
    }
  }, {
    key: "options",
    value: function options(url, config) {
      var _this4 = this;

      return new Promise(function (resolve, reject) {
        _axios.default.options(url, _this4._updateConfig(config)).then(function (res) {
          resolve(res);
        }).catch(function (err) {
          if (err.response !== undefined) {
            if (err.response.status === 401) {
              return _Authentication.default.logout();
            }
          }

          reject(err);
        });
      });
    }
  }, {
    key: "post",
    value: function post(url, data, config) {
      var _this5 = this;

      return new Promise(function (resolve, reject) {
        _axios.default.post(url, data, _this5._updateConfig(config)).then(function (res) {
          resolve(res);
        }).catch(function (err) {
          if (err.response !== undefined) {
            if (err.response.status === 401) {
              return _Authentication.default.logout();
            }
          }

          reject(err);
        });
      });
    }
  }, {
    key: "put",
    value: function put(url, data, config) {
      var _this6 = this;

      return new Promise(function (resolve, reject) {
        _axios.default.put(url, data, _this6._updateConfig(config)).then(function (res) {
          resolve(res);
        }).catch(function (err) {
          if (err.response !== undefined) {
            if (err.response.status === 401) {
              return _Authentication.default.logout();
            }
          }

          reject(err);
        });
      });
    }
  }, {
    key: "patch",
    value: function patch(url, data, config) {
      var _this7 = this;

      return new Promise(function (resolve, reject) {
        _axios.default.patch(url, data, _this7._updateConfig(config)).then(function (res) {
          resolve(res);
        }).catch(function (err) {
          if (err.response !== undefined) {
            if (err.response.status === 401) {
              return _Authentication.default.logout();
            }
          }

          reject(err);
        });
      });
    }
  }]);

  return APIRequest;
}();

var _default = new APIRequest();

exports.default = _default;